import { createSelector } from 'reselect';
export const selectUI = createSelector(
    state => state.ui,
    ui => ui,
);
export const getAlertUser = state => state.alertUser;

export const selectActiveNotificationId = createSelector(
    state => state.ui,
    ui => ui.activeNotification,
);
export const selectActiveDiscoverId = createSelector(
    state => state.ui,
    ui => ui.active_discover_id,
);

export const selectActiveDiscoverLocation = createSelector(
    state => state.ui,
    ui => ui.active_discover_location,
);
export const selectActiveDiscoverParentList = createSelector(
    state => state.ui,
    ui => ui.active_discover_parent_list,
);

export const selectLoadingStats = createSelector(
    state => state.ui,
    ui => ui.loadingStats,
);
